import { alpha, createTheme } from '@mui/material/styles';

// Единый источник цветов: дублируются в CSS-переменных (index.scss),
// чтобы SCSS-модули и MUI выглядели одинаково
export const colors = {
    bg: '#0b0f17',
    surface: '#121826',
    surfaceRaised: '#1a2233',
    border: 'rgba(255, 255, 255, 0.08)',
    text: '#e6e9ef',
    textMuted: '#8b93a7',
    accent: '#f2b544',
    primary: '#e5533d',
    radiant: '#4ade80',
    dire: '#f87171',
};

export const fonts = {
    body: '"Inter", system-ui, -apple-system, "Segoe UI", sans-serif',
    display: '"Rajdhani", "Inter", sans-serif',
};

export const theme = createTheme({
    palette: {
        mode: 'dark',
        primary: { main: colors.primary },
        secondary: { main: colors.accent },
        success: { main: colors.radiant },
        error: { main: colors.dire },
        background: { default: colors.bg, paper: colors.surface },
        text: { primary: colors.text, secondary: colors.textMuted },
        divider: colors.border,
    },
    shape: { borderRadius: 10 },
    typography: {
        fontFamily: fonts.body,
        h1: { fontFamily: fonts.display, fontWeight: 700 },
        h2: { fontFamily: fonts.display, fontWeight: 700 },
        h3: { fontFamily: fonts.display, fontWeight: 700 },
        h4: { fontFamily: fonts.display, fontWeight: 700 },
        h5: { fontFamily: fonts.display, fontWeight: 600 },
        h6: { fontFamily: fonts.display, fontWeight: 600 },
        button: { textTransform: 'none', fontWeight: 600 },
    },
    components: {
        MuiPaper: {
            styleOverrides: {
                root: {
                    backgroundImage: 'none',
                    border: `1px solid ${colors.border}`,
                },
            },
        },
        MuiButton: {
            defaultProps: { disableElevation: true },
        },
        MuiTableCell: {
            styleOverrides: {
                root: { borderColor: colors.border },
                head: {
                    color: colors.textMuted,
                    fontSize: 12,
                    fontWeight: 600,
                    textTransform: 'uppercase',
                    letterSpacing: '0.04em',
                    backgroundColor: colors.surface,
                },
            },
        },
        MuiTableRow: {
            styleOverrides: {
                root: {
                    '&.MuiTableRow-hover:hover': {
                        backgroundColor: alpha('#fff', 0.03),
                    },
                },
            },
        },
        MuiTooltip: {
            defaultProps: { arrow: true, disableInteractive: true },
            styleOverrides: {
                tooltip: {
                    backgroundColor: colors.surfaceRaised,
                    border: `1px solid ${colors.border}`,
                    fontSize: 13,
                },
                arrow: { color: colors.surfaceRaised },
            },
        },
        MuiAvatar: {
            styleOverrides: {
                root: { backgroundColor: colors.surfaceRaised },
            },
        },
    },
});
